import EntitySettingsNavigateService from "app/Service/Entity/EntitySettingsNavigateService"
import WebPathService, {OPERATION_SETTINGS, SubWebPathService} from "app/Service/System/WebPathService"
import SettingsIcon from "app/WebView/Component/icons/settingsIcon"
import {Module} from "const/Module"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"

const ShowSettingsButton = () => {

  const {modulePath, operation} = WebPathService([
    SubWebPathService.modulePath,
    SubWebPathService.operation,
  ], 'ShowSettingsIcon')

  const {navigateToSettings, navigateOutOfSettings} = EntitySettingsNavigateService()

  const [showSettingsIcon, handleShowSettingsIcon] = useState<boolean | undefined>()

  useEffect(() => {
    Logger('Element.ShowSettingsButton.init')
    return () => {
      Logger('Element.ShowSettingsButton.unloading')
    }
  }, [])

  // Let's decide if we should show the settings icon or not.
  // In general, it should always be shown, unless we are doing something from the layout settings
  // Or when we are in client settings.
  useEffect(() => {
    const showIcon = modulePath !== Module.user && modulePath !== Module.client && modulePath !== Module.system
    handleShowSettingsIcon(showIcon)
  }, [modulePath])

  function toSettingsPage() {
    if (undefined === operation) return
    if (operation === OPERATION_SETTINGS) {
      navigateOutOfSettings()
    } else {
      navigateToSettings()
    }
  }

  return !showSettingsIcon ? null : (
    <SettingsIcon
      id={'to-module-settings'}
      onClick={() => toSettingsPage()}
      variant={`primary`}
      active={operation === OPERATION_SETTINGS}
      style={{justifySelf: 'stretch'}}
    />
  )
}

export default ShowSettingsButton
